import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from 'ax/components/CircularProgress';
import SvgFileIcon from 'ax/components/SvgFileIcon';
import SingleStage from 'ax/components/AxStagesDrawer/components/SingleStage';

/* eslint-disable camelcase */
class AxStagesDrawerContent extends React.PureComponent {
  static propTypes = {
    progress: PropTypes.number,
    rotation: PropTypes.number,
    stages: PropTypes.array,
    brandLogoUrl: PropTypes.string,
    axPalette: PropTypes.object,
    progressFraction: PropTypes.string,
    translations: PropTypes.object,
    isMultiStageDrawer: PropTypes.bool,
    subStages: PropTypes.array,
    portalUrl: PropTypes.string,
  }

  _renderStageRow = (stage, stageCompleted) => {
    const { isMultiStageDrawer, axPalette: { primary } } = this.props;

    return (
      <React.Fragment>
        <div className="stage-circle">
          <SvgFileIcon name={stage.name} className="ax-stage-icon" color="#B5B4B8" />
          <div className="stage-inner-circle" style={{ backgroundColor: stage.selected || stageCompleted ? primary : '' }} />
        </div>
        <div className="ax-menu-item-text" style={{ color: stage.selected || stageCompleted ? primary : '' }}>
          {stage.portal_title || stage.title}
          {
            stage.selected && !isMultiStageDrawer ?
              <span className="ax-selected-text-circle" /> :
              null
          }
        </div>
      </React.Fragment>
    );
  }

  _renderStageRowWithLink = (stage, stageCompleted) => {
    const { portalUrl } = this.props;

    if (stage.selected && stage.name === 'MultiStage') {
      return (
        <a href={portalUrl}>
          {this._renderStageRow(stage, stageCompleted)}
        </a>
      );
    }

    return this._renderStageRow(stage, stageCompleted);
  }

  _renderSubStageRow = (subStg, stageCompleted) => {
    const { axPalette: { primary } } = this.props;

    return (
      <div
        key={subStg.id}
        className="ax-menu-item multi-stage-drawer-sub-stage"
      >
        <div className={`stage-circle ${subStg.is_completed && 'stage-circle__completed'}`}>
          <SvgFileIcon name={subStg.type} className="ax-stage-icon" color="#B5B4B8" />
          <div className="stage-inner-circle" />
        </div>
        <div className="ax-menu-item-text" style={{ color: subStg.selected || stageCompleted ? primary : '' }}>
          {subStg.portal_title || subStg.name}
          {
            subStg.is_selected ?
              <span className="ax-selected-text-circle" /> :
              null
          }
        </div>
      </div>
    );
  }

  _renderSubStageRowWithLink = (subStg, stageCompleted) => {
    if (!subStg.is_completed) {
      return (
        <a href={subStg.url} key={`drawer-link-${subStg.id}`}>
          {this._renderSubStageRow(subStg, stageCompleted)}
        </a>
      );
    }

    return this._renderSubStageRow(subStg, stageCompleted);
  }

  render() {
    const {
      progress,
      rotation,
      stages,
      brandLogoUrl,
      progressFraction,
      translations,
      isMultiStageDrawer,
      subStages,
      axPalette: {
        grey_1,
        grey_3,
        grey_4,
        primary,
      },
    } = this.props;
    let stageCompleted = true;

    return (
      <div className="ax-side-menu__content">
        <div className="ax-side-menu-header">
          <img src={brandLogoUrl} className="ax-side-menu-logo" alt="brand-logo" />
        </div>
        {
          stages.length > 1 || isMultiStageDrawer ?
            <React.Fragment>
              <div className="ax-side-menu__progress">
                <CircularProgress
                  progress={progress}
                  rotation={rotation}
                  color={primary}
                  backgroundColor={grey_4}
                  primaryTextColor={grey_1}
                  secondaryTextColor={grey_3}
                  progressFraction={progressFraction}
                />
              </div>
              <div className="ax-menu-stages-container">
                {
                  stages.map((stage) => {
                    let menuItemClasses = '';
                    if (stage.selected) {
                      stageCompleted = false;
                      if (isMultiStageDrawer) {
                        menuItemClasses = '';
                      } else {
                        menuItemClasses = 'ax-menu-item__selected';
                      }
                    } else if (stageCompleted) {
                      menuItemClasses = 'ax-menu-item__completed';
                    }

                    if (stage.hidden) {
                      return null;
                    }

                    return (
                      <div key={`drawer-item-${stage.id}`}>
                        <div className={`ax-menu-item ${menuItemClasses}`}>
                          {this._renderStageRowWithLink(stage, stageCompleted)}
                        </div>
                        <div className="multi-stage-sub-stages">
                          {
                            isMultiStageDrawer && subStages && subStages.map((subStg) => {
                              if (subStg.parent_stage_id === stage.id) {
                                return this._renderSubStageRowWithLink(subStg);
                              }
                              return null;
                            })
                          }
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </React.Fragment> :
            <SingleStage translations={translations} stage={stages && stages[0]} />
        }


        {/* Hidden until we need it
          <div className="ax-menu-card-container">
            <a className="ax-menu-card" href="mailto:support@fountain.com">
              <div className="ax-menu-card-text">
                <div className="ax-help-text">Do you need help?</div>
                <div className="ax-write">Write to us!</div>
              </div>
              <div className="ax-menu-chat-circle" />
            </a>
          </div>
        */}
      </div>
    );
  }
}

export default AxStagesDrawerContent;
